export default "__VITE_ASSET__3cd322b2__"